import { DateTime } from "luxon";
import type { LocationQuery, LocationQueryRaw, RouteLocationRaw } from "vue-router";

export type DataMaintenanceRouteValues = {
  costCenterIds: number[];
  datapointTypeIds: number[];
  time: [DateTime, DateTime];
  siteId?: number;
};

export function getDataMaintenanceRoute(values: DataMaintenanceRouteValues): RouteLocationRaw {
  return {
    name: "DataMaintenanceNew",
    query: {
      costCenterIds: values.costCenterIds,
      datapointTypeIds: values.datapointTypeIds,
      time: values.time.map((time) => time.toISO()),
      siteId: values.siteId,
    } satisfies LocationQueryRaw,
  };
}

function getQueryValues(value: LocationQuery[string]) {
  return (Array.isArray(value) ? value : [value]).filter((entry): entry is string => entry != null);
}

export function parseNumberQuery(value: LocationQuery[string]) {
  return getQueryValues(value)
    .map(Number)
    .filter((entry) => Number.isInteger(entry));
}

export function parseTimeQuery(value: LocationQuery[string]): [DateTime, DateTime] | undefined {
  const times = getQueryValues(value).map((entry) => DateTime.fromISO(entry));
  if (times.length !== 2 || times.some((time) => !time.isValid)) {
    return undefined;
  }
  return [times[0], times[1]];
}
